import React from "react";
import { Button } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
export function FormFooterStart(_a) {
    var handleSubmit = _a.handleSubmit, onSubmit = _a.onSubmit, buttonMessageId = _a.buttonMessageId;
    return (React.createElement(Button, { type: "submit", buttonStyle: "primary", marginBottom0: true, onClick: handleSubmit(onSubmit) },
        React.createElement(FormattedMessage, { id: buttonMessageId })));
}
